import {
  PUBLIC_ANALYTICS_ACCEPTED,
  PUBLIC_ANALYTICS_DECLINED,
  readPublicAnalyticsConfig,
  readPublicAnalyticsConsent,
  setPublicAnalyticsBannerVisible,
  writePublicAnalyticsConsent
} from './publicAnalyticsConsent.js';
import {
  initializePublicAnalyticsProviders,
  resetPublicAnalyticsProviderStateForTests
} from './publicAnalyticsProviders.js';

export const initializePublicAnalytics = async (doc = document) => {
  const config = readPublicAnalyticsConfig(doc);
  if (!config.enabled) return false;
  if (readPublicAnalyticsConsent(doc) !== PUBLIC_ANALYTICS_ACCEPTED) return false;

  await initializePublicAnalyticsProviders(config, doc);

  return true;
};

export const initPublicAnalyticsConsent = (doc = document) => {
  const config = readPublicAnalyticsConfig(doc);
  const banner = doc.querySelector('[data-public-analytics-consent]');

  if (!config.enabled) {
    setPublicAnalyticsBannerVisible(banner, false);
    return false;
  }

  const consent = readPublicAnalyticsConsent(doc);
  if (consent === PUBLIC_ANALYTICS_ACCEPTED) {
    setPublicAnalyticsBannerVisible(banner, false);
    initializePublicAnalytics(doc);
    return true;
  }

  if (consent === PUBLIC_ANALYTICS_DECLINED) {
    setPublicAnalyticsBannerVisible(banner, false);
    return false;
  }

  setPublicAnalyticsBannerVisible(banner, true);
  return true;
};

const bindPublicAnalyticsConsent = (doc = document) => {
  if (doc.documentElement.dataset.publicAnalyticsConsentBound === 'true') return;

  doc.addEventListener('click', (event) => {
    const accept = event.target.closest('[data-public-analytics-accept]');
    const decline = event.target.closest('[data-public-analytics-decline]');

    if (!accept && !decline) return;

    event.preventDefault();
    writePublicAnalyticsConsent(accept ? PUBLIC_ANALYTICS_ACCEPTED : PUBLIC_ANALYTICS_DECLINED, doc);
    setPublicAnalyticsBannerVisible(doc.querySelector('[data-public-analytics-consent]'), false);

    if (accept) initializePublicAnalytics(doc);
  });

  doc.documentElement.dataset.publicAnalyticsConsentBound = 'true';
};

export const initPublicAnalytics = (doc = document) => {
  bindPublicAnalyticsConsent(doc);
  return initPublicAnalyticsConsent(doc);
};

export const trackPublicAnalyticsPageView = (doc = document) => initializePublicAnalytics(doc);

export const resetPublicAnalyticsStateForTests = () => {
  resetPublicAnalyticsProviderStateForTests();
};
